// Copyright (c) 2020 WiseTime. All rights reserved.

import { lazy } from "react"
import { RouteProps } from "react-router"
import { isDevelopmentEnv } from "app/config"
import encodeLastPath from "../lib/lastpath"
import { t } from "@lingui/macro"
import { activateI18n } from "locales/i18nUtil"

activateI18n()

export const getBaseUrl = (): string =>
  isDevelopmentEnv() ? "https://wisetime.ninja" : ""

export const autoNarrativeHelpUrl = "https://help.wisetime.com/hc/en-us/articles/15961800034839"

export const BASE_PATH = "timeline"

export const TIMELINE_BASE_PATH = "/day/"
export const TRASH_BASE_PATH = "/trash/"

export const ROUTE_PATH = {
  TIMELINE: {
    path: `${TIMELINE_BASE_PATH}:date?`,
    title: t({ id: "label_my_timeline", message: "My Timeline" }),
  },
  TRASH: {
    path: `${TRASH_BASE_PATH}:month?`,
    title: t({ id: "label_trash", message: "Trash" }),
  },
  NARRATE_PREFERENCES: {
    path: "/ai-narrative-preferences",
    title: t({ id: "label_ai_narrative_preferences", message: "AI Narrative Preferences" }),
  },
}

export type RouteDefinition = {
  title: string,
  main?: React.ComponentType<any>,
  sidebar?: React.ComponentType<any>,
} & RouteProps

export const ROUTES: RouteDefinition[] = [
  {
    path: ROUTE_PATH.TIMELINE.path,
    title: ROUTE_PATH.TIMELINE.title,
    main: lazy(() => import("features/timeline/")),
    sidebar: lazy(() => import("features/shared/WtSidebar")),
  },
  {
    path: ROUTE_PATH.TRASH.path,
    title: ROUTE_PATH.TRASH.title,
    main: lazy(() => import("features/timeline/trash/")),
    sidebar: lazy(() => import("features/shared/WtSidebar")),
  },
  {
    path: ROUTE_PATH.NARRATE_PREFERENCES.path,
    title: ROUTE_PATH.NARRATE_PREFERENCES.title,
    main: lazy(() => import("features/narrate-preferences/")),
    sidebar: lazy(() => import("features/shared/WtSidebar")),
  },
]

export const getLoginPath = (returnPath?: string): string => {
  const getCurrentPath = (): string => window.location.pathname
  const lastPath = returnPath || getCurrentPath()
  return `${getBaseUrl()}/customer/?lp=${encodeLastPath(lastPath)}`
}

export const getLogoutPath = (): string => `${getBaseUrl()}/customer/logout`

export const getAddTeamPath = (): string => `${getBaseUrl()}/account/#/add-team`

export const getTimelineLegacyPath = (): string => `${getBaseUrl()}/console/#/my-time/:date`
